import React from 'react';
import {Feedback} from "../../types/Feedback";
import {concatenate} from "../../services/string";
import {FeedbackType} from "../../types/FeedbackType";
import StarRating from "../StarRating";
import LikeDislike from "../LikeDislike";

// Types ----

type CommentProps = {
  feedback: Feedback
  isLast?: boolean
};

// Component ----

function Comment({feedback, isLast}: CommentProps) {
  return (
    <>
      <div
        className={concatenate(
          isLast ? 'h-6' : '-bottom-6',
          'absolute left-0 top-0 flex w-6 justify-center'
        )}
      >
        <div className="w-px bg-gray-200"/>
      </div>

      <div className='relative mt-3 h-6 w-6 flex-none rounded-full bg-gray-300 overflow-hidden'>
        {feedback.author &&
          <img
            src={feedback.author.profile_photo_url}
            alt={feedback.author.name ?? 'User profile photo'}
          />
        }
      </div>

      <div className="flex-auto rounded-md p-3 ring-1 ring-inset ring-gray-200">
        <div className="flex justify-between gap-x-4">
          <div className="py-0.5 text-xs leading-5 text-gray-500">
            <span className="font-medium text-gray-900">{feedback.author?.name ?? '<No user>'}</span>

            {feedback.type === FeedbackType.CUSTOMER_SATISFACTION &&
              <StarRating max={5} score={feedback.score} />
            }

            {feedback.type === FeedbackType.LIKE_DISLIKE &&
              <LikeDislike score={feedback.score} />
            }
          </div>

          <time dateTime={feedback.created_at.toISO()} className="flex-none py-0.5 text-xs leading-5 text-gray-500">
            {feedback.created_at.toRelative()}
          </time>

        </div>
        <p className="text-sm leading-6 text-gray-500">{feedback.comments}</p>
      </div>
    </>
  );
}

// Export ----

export default Comment;